/* Lithoforma: add a "View all" link to the bottom of each category submenu
   in the mobile menu drawer, pointing to that category's collection.

   Category parents are <summary> toggles (no href), so we identify each
   submenu by its <details> summary title and map it to an explicit URL. */
(function () {
  var VIEW_ALL_TEXT = 'View all';

  // Map: normalized category title -> collection URL.
  var URLS = {
    'facade & cladding': '/collections/wall-cladding-facades',
    'flooring & paving': '/collections/flooring-paving',
    'garden & landscaping': '/collections/garden-landscaping'
  };

  function normalize(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function urlForTitle(title) {
    for (var key in URLS) {
      if (Object.prototype.hasOwnProperty.call(URLS, key) && title.indexOf(key) !== -1) {
        return URLS[key];
      }
    }
    return null;
  }

  function addViewAllLinks() {
    var lists = document.querySelectorAll('.menu-drawer__menu--childlist');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (list.querySelector('.lf-view-all')) continue;

      var details = list.closest('details');
      if (!details) continue;
      var summary = details.querySelector(':scope > summary');
      if (!summary) continue;

      var url = urlForTitle(normalize(summary.textContent));
      if (!url) continue;

      var li = document.createElement('li');
      li.className = 'menu-drawer__menu-item-list-item lf-view-all';

      var a = document.createElement('a');
      a.className = 'menu-drawer__menu-item menu-drawer__menu-item--child';
      a.setAttribute('href', url);
      a.textContent = VIEW_ALL_TEXT;

      li.appendChild(a);
      list.appendChild(li);
    }
  }

  function init() {
    addViewAllLinks();

    var root = document.getElementById('header-component') || document.body;
    if (root && window.MutationObserver) {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          addViewAllLinks();
        });
      });
      observer.observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
